import React from "react";
import "./Home.css";

function AirConditioning() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>Air Conditioning</h1>
            <p className="home-subtitle">
              <img className="brandImg" src="/dometic.png" />
              <br />
              RTX 2000
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/1K11tf91uRlsozHPivlMwzpNLYnTm1qin/preview"></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          The AC is the biggest battery drainer in the van. For this reason, we recommend a conservation mindset while using. The AC is great for cooling down the van after a long day out in nature, but it isn’t meant to run all day or all night. We’ve provided a battery powered/USB fan to help keep the van cool while sleeping.
        </p>
        <p className="tealText">
          Press the power button on the AC unit to turn it on. The remote will not work until you manually press this button on the unit.
        </p>
        <p className="tealText">
          Eco mode will help conserve battery power. We recommend keeping it in eco mode most of the time.
        </p>
        <p className="tealText">
          Boost mode will cool down the van quickly. Use sparingly.
        </p>
        <p className="tealText">
          Once you push the power button to turn off the AC, the fan will continue running for about 30 seconds before completely shutting down.
        </p>
        <p className="tealText">
          To turn the blue light off while sleeping, hit the power button to completely shut off the AC unit.
        </p>
      </div>

      <div className="movCont">
        <img src="/aircon.jpg" className="home-image" />
      </div>
    </div>
  );
}

export default AirConditioning;
